import * as c from "../../constants/grades";

export const baseResponse = {
  id: 0,
  questionId: 0,
  answerId: 0,
  answerText: "",
  attempts: 1,
  checking: false,
  isCorrect: false,
  isAnswered: false,
  score: 0,
  correctAnswerId: 0,
  correctAnswerText: "",
  explanation: "",
  exerciseCode: ""
};

export const defaultState = [];

const mergeResponse = (state, questionId, params) => {
  const index = state.findIndex(item => item.questionId === questionId);
  if (index < 0) {
    return [...state, { ...baseResponse, questionId, ...params }];
  } else {
    return [
      ...state.slice(0, index),
      { ...state[index], ...params },
      ...state.slice(index + 1)
    ];
  }
};

const responses = (state = defaultState, action) => {
  switch (action.type) {
    case c.GRADE_LOAD_GRADE_RESPONSES:
      if (!Array.isArray(action.responses)) {
        return state;
      }
      return action.responses;

    case c.GRADE_BEGIN_SUCCESS:
    case c.GRADE_FINISH_SUCCESS:
      if (!Array.isArray(action.result.responses)) {
        return state;
      }
      return action.result.responses.reduce(
        (all, curr) => mergeResponse(all, curr.questionId, curr),
        state
      );

    case c.GRADE_RETAKE_SUCCESS:
      const filtered = state.filter(r => r.exerciseCode !== action.code);
      return action.result.responses.reduce(
        (all, curr) => mergeResponse(all, curr.questionId, { exerciseCode: action.code, ...curr }),
        filtered
      );

    case c.GRADE_SUBMIT_ANSWER:
      return mergeResponse(state, action.questionId, {
        checking: true,
        answerId: action.answerId
      });

    case c.GRADE_SUBMIT_ANSWER_SUCCESS:
      return mergeResponse(state, action.result.response.questionId, {
        checking: false,
        ...action.result.response
      });

    case c.GRADE_SUBMIT_ANSWER_FAILURE:
      // TODO: should we handle an error here?
      return mergeResponse(state, action.result.questionId, {
        checking: false
      });

    default:
      return state;
  }
};

export default responses;
